/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Original_LabelInputs */

const en_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original media`)
};

const fr_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médias originaux`)
};

const de_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalmedien`)
};

const it_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiale originale`)
};

const ru_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оригинальные медиа`)
};

const es_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios originales`)
};

const zh_cn2_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原始媒体`)
};

const ja_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルメディア`)
};

const hi_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल मीडिया`)
};

const pt_pt2_audio_embed_export_original_label = /** @type {(inputs: Audio_Embed_Export_Original_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia original`)
};

/**
* | output |
* | --- |
* | "Original media" |
*
* @param {Audio_Embed_Export_Original_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_original_label = /** @type {((inputs?: Audio_Embed_Export_Original_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Original_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_original_label(inputs)
	if (locale === "de") return de_audio_embed_export_original_label(inputs)
	if (locale === "it") return it_audio_embed_export_original_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_original_label(inputs)
	if (locale === "es") return es_audio_embed_export_original_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_original_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_original_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_original_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_original_label(inputs)
	return en_audio_embed_export_original_label(inputs)
});